<template>
  <div class="foot">
    <div class="row">
      <div class="row-item col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <h3>Products</h3>
        <div>
          <p @click="toUrl('http://view.cadwonder.net/')">DWG Fastview Plus</p>
          <p @click="toUrl(threedUrl)">3D FastView</p>
        </div>
      </div>
      <div class="row-item col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <h3>Contact Us</h3>
        <div>
          <p>Sales : sales@cadwonder.net</p>
          <p>Support : support@cadwonder.net</p>
        </div>
      </div>
      <div class="row-item col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <img id="foot-logo" src="../../static/images/foot-logo@2x.png" alt="">
        <div class="footer-follow-us-div">
          <span @click="toUrl('https://www.linkedin.com/company/suzhou-gstarsoft-co-ltd/')" class="icon iconfont viewlinkedin"></span>
          <span @click="toUrl('https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w')" class="icon iconfont viewyoutube"></span>
          <span @click="toUrl('https://www.facebook.com/cadwonder/')" class="icon iconfont viewicon_facebook"></span>
          <span @click="toUrl('https://twitter.com/Gstarsoft_CAD')" class="icon iconfont viewtwitter"></span>
        </div>
      </div>
    </div>
    <p id="foot-copy">©Copyright 2018-2019 Gstarsoft Co.,Ltd. All rights reserved.</p>
  </div>
</template>

<script>
import {baseUrl3D} from '../../config/build-config'
export default {
  data () {
    return {
      threedUrl:baseUrl3D  
    }
  },
  methods: {
    toUrl(path){
      window.location.href = path
    }
  },
};
</script>

<style lang="scss">
@import "../../static/css/foot.scss";
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue